<template>
    <v-card tile class="overflow-hidden">
        <v-app-bar
            absolute
            color="white"
            elevate-on-scroll
            scroll-target="#scrolling-techniques-7"
            height="40"
        >
            <v-tabs
                center-active
                color="primary"
                height="40"
            >
                <template v-for="(cat, i) in categorieList">
                    <v-tab @click="filterProducts(cat.id)">
                        {{ cat.name }}
                    </v-tab>
                </template>
            </v-tabs>
        </v-app-bar>
        <v-sheet
            id="scrolling-techniques-7"
            class="overflow-y-auto"
            max-height="400"
        >
            <v-container fluid style="height: 380px;" class="pt-6">
                <v-row class="mt-5">
                    <v-col cols="12" sm="6" md="4" v-for="(prod, j) in productList" :key="j">
                        <v-card
                            class="mx-auto"
                            color="grey lighten-4"
                            height="100%"
                            @click="$emit('selected', prod)"
                        >
                            <v-img
                                :aspect-ratio="16/9"
                                :src="prod.banner"
                                style="cursor:pointer;"
                            ></v-img>
                            <v-card-text
                                class="pa-2"
                                style="position: relative;"
                            >
                                <h4 class="mb-0">
                                    {{ prod.name }}
                                </h4>
                                <div class="mb-2 caption" v-if="typeStore=='product'">
                                    <span v-if="prod.code">{{ $t('Cod. prod.:') }} {{ prod.code }}</span> <br>
                                    <span v-if="prod.barcode">{{ $t('Cod. barra:') }} {{ prod.barcode }}</span>
                                </div>
                                <div class="text-right">
                                    <strong class="primary--text">
                                        {{ money }} {{ (prod.price).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2}) }}
                                    </strong>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-sheet>
        
        
    </v-card>
</template>
<script>
export default {
    data() {
        return {
            tab: null,
            categorieList: [],
            productList: []
        }
    },
    props: ['money', 'typeStore'],
    mounted() {
        this.getCategories()
    },
    methods: {
        async getCategories() {
            await axios.post('/admin/list-categories', {})
            .then(response => {
                // console.log(response);
                this.categorieList = response.data
                this.tab = this.categorieList[0].id
                setTimeout(() => {
                    this.filterProducts(this.categorieList[0].id)
                }, 300);
            })
            .catch(error => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        },
        async filterProducts(id) {
            // this.tab = id
            this.productList = []
            await axios.post('/admin/prods-by-cat', {cat: id, show:'prod'})
            .then((response) => {
                // console.log(response);
                this.productList = response.data
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        }
    }
}
</script>